import React from "react";

import { isAncillaryContentSubtype } from "../types/AncillaryContentType";
import { ContentSubtype } from "../types/ContentSubtype";

interface AncillaryComponentRendererProps {
    subtype?: ContentSubtype;
    children: React.ReactNode;
}

export const AncillaryComponentRenderer: React.FC<AncillaryComponentRendererProps> = ({
    subtype,
    children
}: AncillaryComponentRendererProps) => {
    if (subtype && isAncillaryContentSubtype(subtype)) {
        return <>{children}</>;
    }

    return <></>;
};
